const isMessageArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === "string");

export const readErrorMessage = async (
  response: Response,
  fallback: string,
): Promise<string> => {
  const rawBody = await response.text();

  if (!rawBody) {
    return fallback;
  }

  try {
    const parsed = JSON.parse(rawBody) as { message?: unknown };

    if (typeof parsed.message === "string") {
      return parsed.message;
    }

    if (isMessageArray(parsed.message)) {
      return parsed.message.join(", ");
    }
  } catch {
    return rawBody;
  }

  return fallback;
};
